module.exports = __webpack_public_path__ + "static/img/videoMatchBannerBg.42eb49b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/videoMatchBannerBg.jpg
// module id = 559
// module chunks = 2 8